<script setup lang="ts">
import GeneralAnnouncementsUtil from "@/utils/common/GeneralAnnouncementsUtil.ts";

const announcements = GeneralAnnouncementsUtil.announcements;
const index = GeneralAnnouncementsUtil.index;
</script>

<template>
  <div class="tw-flex tw-items-center tw-gap-[5px]">
    <div v-for="(announcement, dot) in announcements" :key="announcement.key"
         class="tw-h-[5px] tw-rounded-[3px] tw-cursor-pointer tw-transition-[width,background-color] tw-duration-[250ms]"
         :class="dot === index ? 'tw-w-4 tw-bg-primary-light dark:tw-bg-primary-dark' : 'tw-w-[5px] tw-bg-gray-400'"
         @click="GeneralAnnouncementsUtil.goTo(dot)"></div>
  </div>
</template>
